import React, { useState, useMemo, useEffect } from "react";

// Load images from src/assets/myphotos using webpack's require.context
const importAll = (r) => r.keys().map(r);
let IMAGES = [];
try {
  IMAGES = importAll(
    require.context("../assets/myphotos", false, /\.(jpe?g|png|svg|webp)$/i)
  );
} catch (e) {
  // In non-webpack environments this will fail silently and IMAGES will be empty
  IMAGES = [];
}

export default function PhotoModule({
  // Parent should position this element (absolute left/top). Component itself
  // does not convert world → screen coords so it can be placed anywhere.
  thumbSize = 200,
  panelWidth = 720,
  initialIndex = 0,
  images = null, // optional override
}) {
  const all = useMemo(
    () => (images && images.length ? images : IMAGES),
    [images]
  );
  const [, setIndex] = useState(initialIndex);
  // store natural sizes once images load so we can scale to 25% of original
  const [sizes, setSizes] = useState(() => Array(all.length).fill(null));

  // reset sizes if image list changes
  useEffect(() => {
    setSizes(Array(all.length).fill(null));
  }, [all.length]);

  if (!all || all.length === 0) {
    return (
      <div
        style={{
          width: panelWidth,
          padding: 12,
          background: "rgba(0,0,0,0.02)",
          borderRadius: 6,
        }}
      >
        <small style={{ color: "#666" }}>no photos</small>
      </div>
    );
  }

  // Render a plain, borderless flexible grid of photos whose widths are
  // 25% of the original image width, capped at 500px. Height preserves aspect ratio.
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "flex-start",
        width: panelWidth,
      }}
    >
      {all.map((s, i) => {
        const sz = sizes[i];
        const computedWidth = sz
          ? Math.min(Math.round(sz.w * 0.25), 500)
          : Math.min(thumbSize, 500);
        return (
          <img
            key={i}
            src={s}
            alt={`photo-${i}`}
            onClick={() => setIndex(i)}
            onLoad={(e) => {
              const w = e.target.naturalWidth || 0;
              const h = e.target.naturalHeight || 0;
              setSizes((prev) => {
                const next = prev ? prev.slice() : [];
                next[i] = { w, h };
                return next;
              });
            }}
            style={{
              width: computedWidth,
              height: "auto",
              objectFit: "cover",
              display: "block",
              border: "none",
              background: "transparent",
              padding: 0,
              margin: 0,
              cursor: "pointer",
              flex: "0 0 auto",
              maxWidth: 500,
            }}
          />
        );
      })}
    </div>
  );
}
